import styled from "styled-components";
import { Button } from "@mui/material/";
import { styled as muiStyled } from "@mui/material/styles/";
import { primaryColor, secondaryColor } from "../../global/constants";

export const Content = styled.div`
  display: flex;
  color: white;
  flex-direction: column;
  justify-content: space-between;
  height: 90vh;
  overflow-y: auto;
`;

export const FieldsContent = styled.div`
  padding: 5% 10% 0 10%;
  display: flex;
  flex-direction: column;
`;

export const ButtonContent = styled.div`
  padding: 5% 10% 0 10%;
`;

export const ProceedButton = muiStyled(Button)({
  textAlign: "center",
  textTransform: "none",
  fontSize: 16,
  padding: "6px 12px",
  lineHeight: 1.5,
  backgroundColor: primaryColor,
  border: "none",
  height: "50px",
  width: "100%",
  "&:hover": {
    backgroundColor: secondaryColor,
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: secondaryColor,
  },
});

export const Red = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: red;
`;

export const Caption = styled.div`
  padding-bottom: 10px;
  width: 100%;
  font-size: 13px;
`;

export const UnderCaption = styled.div`
  padding-top: 10px;
  width: 100%;
  font-size: 13px;
  font-style: italic;
`;
